import { Button, type ButtonProps, Icon } from '@imprivata-cloud/design-system';
import './no-inline-enrollment.less';

interface InformationDialogProps {
  title?: string;
  text?: string;
  buttonProps?: ButtonProps; 
}

export const InformationDialog = ({
  title,
  text,
  buttonProps
}: InformationDialogProps) => {
  return (
    <div className="information-dialog-root">
      <Icon type="info" className='information-dialog-icon' />
      {title && <h2 className="information-dialog-title">{title}</h2>}
      {text && <p className="information-dialog-text">{text}</p>}
      {buttonProps && (
        <Button variant="primary" size="md" className='information-dialog-button' {...buttonProps} />
      )}
    </div>
  );
};
